import { TicketsPendientes } from './../../../../../common/ticketsPendientes';
import { Fichada } from './../../../../../common/fichada';
import { Action } from '@ngrx/store';
import { NotificacionBundle } from 'src/common/notificacionBundle';

export enum RecursosHumanosActionTypes {
	UltimaFichadaRequested = '[RecursosHumanos Component] Ultima Fichada Requested',
	UltimaFichadaLoaded = '[RecursosHumanos API] UtlimaFichada Loaded',
	TicketsPendientesRequested = '[RecursosHumanos Component] Tickets Pendientes Requested',
	TicketsPendientesLoaded = '[RecursosHumanos API] Tickets Pendientes Loaded'
}

export class UltimaFichadaRequested implements Action {
	readonly type: string = RecursosHumanosActionTypes.UltimaFichadaRequested;
	constructor() {
	}
}

export class UltimaFichadaLoaded implements Action {
	readonly type: string = RecursosHumanosActionTypes.UltimaFichadaLoaded;
	constructor( public payload: { ultimaFichada: NotificacionBundle<Fichada> } ) {
	}
}

export class TicketsPendientesRequested implements Action {
	readonly type: string = RecursosHumanosActionTypes.TicketsPendientesRequested;
	constructor() {
	}
}

export class TicketsPendientesLoaded implements Action {
	readonly type: string = RecursosHumanosActionTypes.TicketsPendientesLoaded;
	constructor( public payload: { ticketsPendientes: NotificacionBundle<TicketsPendientes> } ) {
	}
}

export type RecursosHumanosActions = UltimaFichadaRequested | UltimaFichadaLoaded | TicketsPendientesRequested | TicketsPendientesLoaded;